import { Link } from 'gatsby'
import { ArrowRight } from 'phosphor-react'
import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'

import BookDemoButton from 'components/home-page/book-demo-button'
import { Box, ContentCol } from 'components/layout'
import { Paragraph } from 'components/typography'
import getStyle from 'themes/getStyle'

interface Feature {
  title: string
  children?: Omit<Feature, 'children'>[]
}
interface Props {
  src: string
  title: string
  description: string
  formId: ID
  price?: ReactNode
  features?: Feature[]
  buttonLabel?: string
  children?: ReactNode
  className?: string
  featureRoute: string
  featureLabel?: ReactNode
  includes?: Feature[]
  eventLabel: string
  conversionTrackingId: string
  conversionValue: number
}

const ProductCard: FC<Props> = ({
  buttonLabel = 'Book a demo',
  featureLabel = 'Discover more',
  formId,
  ...props
}) => {
  return (
    <Box fill="main" rounded padding="0" className={props.className}>
      <Box>
        <ContentCol>
          {props.price}
          <BookDemoButton
            primary
            label={buttonLabel}
            formId={formId}
            eventLabel={props.eventLabel}
            conversionTrackingId={props.conversionTrackingId}
            conversionValue={props.conversionValue}
          />
        </ContentCol>
      </Box>
      <Box>
        {props.includes && (
          <>
            <h4>Includes</h4>
            {props.includes?.map((item, index) => {
              return <li key={index}>{item.title}</li>
            })}
          </>
        )}
      </Box>
      <Box>
        {props.features?.map((feature, index) => (
          <div key={index}>
            <h4>{feature.title}</h4>
            {!!feature.children && (
              <ul>
                {feature.children?.map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </Box>
      <Paragraph justify="center">
        <Link
          to={props.featureRoute}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {featureLabel}&nbsp;&nbsp;
          <ArrowRight />
        </Link>
      </Paragraph>
      {props.children}
    </Box>
  )
}

export default styled(ProductCard)`
  display: grid;
  grid-gap: 1em;
  grid-template-rows: min-content 150px 1fr min-content;
  width: 100%;
  max-width: 440px;
  margin: 2em auto;

  h4 {
    margin-bottom: 0.5em;
  }

  ul {
    margin-left: 1em;

    li {
      line-height: 1.5;
    }
  }

  > *:not(:last-child) {
    border-bottom: 1px solid ${getStyle('siteBorderColor')};
  }
`
